import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../Routes/HomePage';
import HomePage2 from '../Routes/HomePage2';
import SubscribePage from '../Routes/SubscribePage';
import LoginPage from '../Routes/LoginPage';
import RedirectPage from '../Routes/RedirectPage';
import Auth from '../Components/Auth';

const Routing = () => {
    const router=createBrowserRouter([
        {
            path:"/home",
            element:
            <Auth>
              <HomePage2 />
            </Auth>
        },
        {
          path:"/",
          element:<SubscribePage />
        },
        {
          path:"/login",
          element:<LoginPage />
        },
        {
          path:"/redirect",
          element:<RedirectPage />
        },
        {
          path:"*",
          element:<Navigate to="/" />
        }
    ])
  return (
    <RouterProvider router={router} />
  )
}

export default Routing